export const QA_NAME_LISTING_PROFILE_ADDRESS_DISCARD = 'listingAddressDiscard'

export const LISTING_PROFILE_ADDRESS_DISCARD_CONFIRMATION_PROPS = {
  description: 'RentalPortal.ListingProfileAddressDiscardTextKey',
  qaName: QA_NAME_LISTING_PROFILE_ADDRESS_DISCARD,
  title: 'RentalPortal.ListingProfileBlockDiscardTitleKey',
}
